import { Component } from '@angular/core';
import {QuoteSummaryComponent} from "@spartacus/quote/components";

@Component({
    selector: 'cx-quote-summary',
    templateUrl: './gonvarri-quote-summary.component.html',
    styleUrl: './gonvarri-quote-summary.component.scss',
    standalone: false
})
export class GonvarriQuoteSummaryComponent extends QuoteSummaryComponent {}
